<template>
  <v-form v-model="valid" ref="mainForm">
    <opq-text-field
      code="enquete_nom"
      v-model="sasDemandeEnquete.nom"
      :live="liveSasDemandeEnquete(23325)"
    ></opq-text-field>

    <opq-text-field
      code="enquete_prenom"
      v-model="sasDemandeEnquete.prenom"
      :live="liveSasDemandeEnquete(23324)"
    ></opq-text-field>

    <opq-text-field
      code="enquete_employeur"
      v-model="sasDemandeEnquete.employeurAuMomentDesFaits"
      :live="liveSasDemandeEnquete(23326)"
      optional
    ></opq-text-field>

    <opq-text-field
      code="enquete_adresse"
      v-model="sasDemandeEnquete.adresseCivique"
      :live="liveSasDemandeEnquete(23327)"
      :id="'adresseCivique'"
      ref="adresseCivique"
      optional
    ></opq-text-field>

    <opq-text-field
      code="enquete_complementadresse"
      v-model="sasDemandeEnquete.complementDAdresse"
      :live="liveSasDemandeEnquete(23328)"
      ref="complementDAdresse"
      optional
    ></opq-text-field>

    <opq-text-field
      code="enquete_cp"
      v-model="sasDemandeEnquete.codePostal"
      :live="liveSasDemandeEnquete(23329)"
      is-code-postal
      :code-pays="codePays(sasDemandeEnquete.pays)"
      ref="codePostal"
      optional
    ></opq-text-field>

    <opq-text-field
      code="enquete_ville"
      v-model="sasDemandeEnquete.ville"
      :live="liveSasDemandeEnquete(23330)"
      ref="ville"
    ></opq-text-field>

    <opq-catalogue
      code="enquete_province"
      v-model="sasDemandeEnquete.province"
      :opq-if="paysEstUSouCA(sasDemandeEnquete.pays)"
      :live="liveSasDemandeEnquete(23331)"
      :parent="sasDemandeEnquete.pays"
      order-by="text"
      ref="province"
    ></opq-catalogue>

    <opq-catalogue
      code="enquete_pays"
      v-model="sasDemandeEnquete.pays"
      :live="liveSasDemandeEnquete(23332)"
      ref="pays"
      order-by="text"
      optional
    ></opq-catalogue>

    <opq-text-field
      code="enquete_telephone"
      v-model="sasDemandeEnquete.numeroDeTelephone"
      :live="liveSasDemandeEnquete(23333)"
      is-phone-number
      optional
    ></opq-text-field>

    <opq-text-field
      code="enquete_courriel"
      v-model="sasDemandeEnquete.adresseCourriel"
      :live="liveSasDemandeEnquete(23334)"
      is-email
      optional
    ></opq-text-field>

    <opq-text-field
      code="enquete_nopermis"
      v-model="sasDemandeEnquete.numeroPermis"
      :live="liveSasDemandeEnquete(23335)"
      optional
    ></opq-text-field>

    <opq-catalogue
      code="enquete_client"
      v-model="sasDemandeEnquete.etesVousLeClient"
      :live="liveSasDemandeEnquete(23336)"
    ></opq-catalogue>

  </v-form>
</template>

<script>
import FormSimple from "@/mixins/FormSimple"
import CataloguesHelper from "@/mixins/CataloguesHelpers"
import PosteCanada from "@/mixins/PosteCanada"

export default {
  mixins: [FormSimple, CataloguesHelper, PosteCanada],
  props: {
    sas: { type: Object }
  },

  data: () => ({
    posteCanadaMainconfig: {
      searchFieldId: "adresseCivique",
      adresseKey: "adresseCivique",
      completementDAdresseKey: "complementDAdresse",
      villeKey: "ville",
      codePostalKey: "codePostal",
      provinceKey: "province",
      paysKey: "pays"
    }
  }),

  computed: {
    sasDemandeEnquete() {
      return this.sas.sasDemandeEnquete
    },
  },

  methods: {
    liveSasDemandeEnquete(cle) {
      return { endpoint: "/sas-demande-enquete/", cle: cle, fileId: this.sasDemandeEnquete.id }
    }
  }
}
</script>

<style>
</style>